import type { CardAction, Piece } from '../shared/types';

export interface CardBoardTarget { nodeId: string; sourceIds: string[]; actions: CardAction[] }

/** A shared stack is one board target; retain all server action keys until selection. */
export function cardBoardTargets(actions: CardAction[], pieces: Piece[], sourceId?: string): { stage: 'source' | 'target'; targets: CardBoardTarget[] } {
  const sources = [...new Set(actions.map(action => action.sourceId).filter((id): id is string => Boolean(id)))];
  const stage = !sourceId && sources.length > 1 ? 'source' : 'target';
  const selectedSource = sourceId ?? sources[0];
  const groups = new Map<string, CardBoardTarget>();
  for (const action of actions) {
    if (stage === 'target' && selectedSource && action.sourceId !== selectedSource) continue;
    const pieceId = stage === 'source' ? action.sourceId : action.targetId;
    const position = pieceId ? pieces.find(piece => piece.id === pieceId)?.position : action.to ?? pieces.find(piece => piece.id === action.sourceId)?.position;
    if (!position || position === 'FINISH') continue;
    const group = groups.get(position) ?? { nodeId: position, sourceIds: [], actions: [] };
    if (action.sourceId && !group.sourceIds.includes(action.sourceId)) group.sourceIds.push(action.sourceId);
    group.actions.push(action); groups.set(position, group);
  }
  return { stage, targets: [...groups.values()] };
}
